// assets/wc-dom.js
// Shared DOM helpers used by every other wc-* module.
// Pure utility — no module-level state, no side effects, no dependencies.

/** Returns first element matching selector under root (or document). */
export const qs = (sel, root = document) => root.querySelector(sel);

/** Returns all elements matching selector under root, as a real array (not NodeList). */
export const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

/** Add event listener. el may be null (no-op). */
export const on = (el, evt, fn, opts) => { if (el) el.addEventListener(evt, fn, opts); };

/** Remove event listener. el may be null (no-op). */
export const off = (el, evt, fn) => { if (el) el.removeEventListener(evt, fn); };

/** Returns a Promise that resolves on next animation frame. */
export const raf = () => new Promise(resolve => requestAnimationFrame(resolve));

/** Run a callback when browser is idle. Falls back to setTimeout on engines without requestIdleCallback. */
export const idle = (fn) => {
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(fn, { timeout: 2000 });
  } else {
    setTimeout(fn, 16);
  }
};

/**
 * Run an array of async work in chunks of perChunk, yielding to browser between chunks.
 * Used to throttle simultaneous work (e.g. image preloads) without blocking main thread.
 */
export async function chunked(items, perChunk, workFn) {
  for (let i = 0; i < items.length; i += perChunk) {
    const chunk = items.slice(i, i + perChunk);
    await Promise.all(chunk.map(workFn));
    await raf();
  }
}

/** Read a cookie value by name; returns empty string if absent. */
export function readCookie(name) {
  const prefix = name + "=";
  for (const part of document.cookie.split(";")) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) return decodeURIComponent(trimmed.slice(prefix.length));
  }
  return "";
}

/** Write a cookie. expiresDays defaults to 365. path defaults to "/". */
export function writeCookie(name, value, expiresDays = 365, path = "/") {
  const d = new Date();
  d.setTime(d.getTime() + expiresDays * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=${path}; SameSite=Lax`;
}
